<script setup>
import { Textarea } from '../../components';
import DarkModeStore from '@o/store'
const { options, isPro } = DarkModeStore()
</script>

<template>
    <Row space class="gap-5">
        
        <Heading>
            <div class="flex items-center gap-3"><span class="text-lg" :class="{'opacity-50 wp-dark-mode-locked' : !isPro}">
                {{__('Dark Mode CSS', 'wp-dark-mode')}}</span> <ProBadge /></div>
            <Hints locked>
                 {{__('Add custom CSS for dark mode only. This CSS will only apply when the dark mode is on. use <code>!important</code> flag on each property', 'wp-dark-mode')}}</Hints>
        </Heading>

        <Row locked>
            <Textarea v-model="options.frontend_custom_css" class="font-mono text-sm" placeholder="Enter custom CSS here" rows="20"></Textarea>
        </Row>
    </Row>
</template>